import { Grid, Theme, useMediaQuery } from "@mui/material";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../store/context";
import { IOperationsStatus, ModalityType } from "../../../types/FaceVerification";
import OperationButtonContained from "../../../components/Operations/styled/OperationButtonContained";
import OperationButtonOutlined from "../../../components/Operations/styled/OperationButtonOutlined";
import OperationTypographyInstruction from "../../../components/Operations/styled/OperationTypographyInstruction";
import OperationTypographyText from "../../../components/Operations/styled/OperationTypographyText";
import OperationTextGrid from "../../../components/Operations/styled/OperationTextGrid";
import OperationTypographyLabelText from "../../../components/Operations/styled/OperationTypographyLabelText";

interface IVerifySideBar {
    subjectId: string
    checkState: IOperationsStatus
    activeModality: ModalityType | null
    start: () => void
    cancel?: () => void
    restart: () => void
}

const VerifySideBar: React.FC<IVerifySideBar> = (props) => {

    const state = useContext(AppContext).state;
    const history = useHistory()
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    const handleSubjectId = () => {
        if (state.prefix) {
            if (props.subjectId.startsWith(state.prefix)) {
                return props.subjectId.substring(state.prefix.length + 1)
            }
        }
        return props.subjectId;
    }

    const getButtons = () => {
        if (props.activeModality === ModalityType.OVERVIEW) {
            return (
                <OperationButtonContained onClick={() => history.push("/")} color="primary" variant="contained">
                    Finish
                </OperationButtonContained>
            )
        }
        switch(props.checkState) {
            case IOperationsStatus.IDLE:
                return (
                    <OperationButtonContained onClick={props.start} color="primary" variant="contained">
                        Start verification
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.ACTIVE:
                return (
                    <OperationButtonContained onClick={props.cancel} color="primary" variant="contained">
                        Cancel
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.DONE:
                return (
                    <>
                        <OperationButtonContained onClick={props.restart} color="primary" variant="contained">
                            Recapturing
                        </OperationButtonContained>
                        <OperationButtonOutlined color="primary" variant="outlined" onClick={() => {history.push("/")}}>
                            Home
                        </OperationButtonOutlined>
                    </>
                )
        }
    }

    const getModalityText = () => {
        switch(props.activeModality) {
            case ModalityType.FACE_MODALITY:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Take a selfie
                                </OperationTypographyInstruction>
                                <OperationTypographyLabelText>
                                    Adjust your position to place your face into oval frame and press Start capture.
                                </OperationTypographyLabelText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
            case ModalityType.VOICE_MODALITY:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Record your voice
                                </OperationTypographyInstruction>
                                <OperationTypographyLabelText>
                                    Press <b>Start verification</b> and speak.
                                </OperationTypographyLabelText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
            case ModalityType.OVERVIEW:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Preview captured data
                                </OperationTypographyInstruction>
                                <OperationTypographyText>
                                    <b>SubjectId:</b> {handleSubjectId()}
                                </OperationTypographyText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
        }
    }

    return (
        <OperationTextGrid item md={2} xs={12} glow={(props.checkState !== IOperationsStatus.ACTIVE && isMobile)}>
            {getModalityText()}
        </OperationTextGrid>
    )
}

export default VerifySideBar